import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { planArea } from '../request';
import { recursionCopy } from '@/views/customer/roleManage/utils';
export default {
  props: ['value', 'termsData', 'attachData', 'selected', 'attachInfo', 'premiumObj'],
  data() {
    return {
      form: {
        clause: undefined,
        attach: [],
        priceMin: '',
        priceMax: ''
      },
      templateData: [{
        id: 1,
        price: undefined
      }],
      templateColumn: [{
        slots: {
          title: '销售区域'
        },
        dataIndex: 'areaName',
        key: 'areaName',
        align: 'center',
        scopedSlots: {
          customRender: 'areaName'
        }
      }, {
        slots: {
          title: '保费'
        },
        dataIndex: 'price',
        key: 'price',
        align: 'center',
        width: '35%',
        scopedSlots: {
          customRender: 'price'
        }
      }, {
        slots: {
          title: '操作'
        },
        dataIndex: 'operation',
        key: 'operation',
        align: 'center',
        width: 100,
        scopedSlots: {
          customRender: 'operation'
        }
      }],
      additionalData: [],
      additionalColumn: [{
        slots: {
          title: '产品名称'
        },
        dataIndex: 'name',
        key: 'name',
        align: 'center'
      }, {
        slots: {
          title: '购买限制'
        },
        dataIndex: 'buyLimit',
        key: 'buyLimit',
        align: 'center',
        width: '35%',
        scopedSlots: {
          customRender: 'buyLimit'
        }
      }, {
        slots: {
          title: '操作'
        },
        dataIndex: 'operation',
        key: 'operation',
        align: 'center',
        width: 100,
        scopedSlots: {
          customRender: 'operation'
        }
      }],
      checkedAdditionalList: [],
      areaList: [],
      areaVisible: false,
      currentArea: [],
      currentAreaShowList: [],
      showArea: [],
      tableAreaName: '',
      tableAreaAllCode: '',
      currentTableIndex: undefined,
      tableDataNum: -1,
      showAreaTable: false
    };
  },
  computed: {
    dataRule() {
      return {
        price: [{
          required: true,
          validator: this.validatePrice
        }],
        clause: [{
          required: true,
          validator: this.validateClause
        }]
      };
    }
  },
  async mounted() {
    if (this.value == 'premium') {
      const res = await planArea({
        level: 2
      });
      this.areaList.splice(0);
      this.areaList.push(...res);
      if (this.premiumObj.price && this.premiumObj.area.length) {
        this.form.priceMin = this.premiumObj.price.split(',')[0];
        this.form.priceMax = this.premiumObj.price.split(',')[1];
        this.$set(this.form, this.form.priceMin, this.form.priceMin);
        this.$set(this.form, this.form.priceMax, this.form.priceMax);
        this.templateData.splice(0);
        this.templateData.push(...this.premiumObj.area);
      }
    }
    if (this.termsData.length) {
      this.initTerm();
    } else {
      this.form.clause = 0;
    }
    if (this.attachInfo && this.attachInfo.length) {
      this.additionalData.splice(0);
      this.form.attach.splice(0);
      this.attachInfo.forEach(item => {
        this.additionalData.push(item);
        this.form.attach.push(item.attachId.toString());
      });
    } else {
      this.additionalData.splice(0);
      this.form.attach.splice(0);
    }
    if (this.form.priceMin && this.form.priceMax) {
      this.showAreaTable = true;
    }
  },
  watch: {
    attachInfo: {
      handler(newV) {
        if (newV.length) {
          this.additionalData.splice(0);
          this.form.attach.splice(0);
          newV.forEach(item => {
            this.additionalData.push(item);
            this.form.attach.push(item.attachId.toString());
          });
        } else {
          this.additionalData.splice(0);
          this.form.attach.splice(0);
        }
      },
      deep: true
    },
    premiumObj: {
      handler(newV) {
        if (newV.price && newV.area.length) {
          // this.form.priceMin = Number(newV.price.split(',')[0]);
          // this.form.priceMax = Number(newV.price.split(',')[1]);

          // this.$set(this.form, this.form.priceMin, this.form.priceMin);
          // this.$set(this.form, this.form.priceMax, this.form.priceMax);
          this.templateData.splice(0);
          this.templateData.push(...newV.area);
        }
      },
      deep: true
    },
    termsData: {
      handler(newV) {
        if (newV && newV.length) {
          this.initTerm();
        } else {
          this.form.clause = 0;
        }
      },
      deep: true
    }
    // selected: {
    //   handler(newV) {
    //     this.selected = newV;
    //     this.initTerm();
    //   },
    //   deep: true
    // }
  },
  methods: {
    validatePrice(rule, value, callback) {
      if (!this.form.priceMin) {
        callback(new Error(this.$t('请输入') + this.$t('最小保费')));
      } else if (!this.form.priceMax) {
        callback(new Error(this.$t('请输入') + this.$t('最大保费')));
      } else if (Number(this.form.priceMin) >= Number(this.form.priceMax)) {
        callback(new Error(this.$t('最大保费不能小于或等于最小保费')));
      } else if (Number(this.form.priceMin) > 40000000 || Number(this.form.priceMax) > 40000000) {
        callback(new Error(this.$t('不能大于40000000')));
      } else {
        this.tableDataNum = -1;
        this.showAreaTable = true;
        callback();
      }
    },
    validateClause(rule, value, callback) {
      console.log(this.checkedAdditionalList);
      if (!this.checkedAdditionalList.length) {
        callback(new Error(this.$t('请选择') + this.$t('条款文件')));
      } else {
        callback();
      }
    },
    initTerm() {
      var _this$checkedAddition;
      if (this.selected && this.selected.length) {
        if (this.selected.length == this.termsData.length) {
          var _this$termsData;
          this.form.clause = 0;
          (_this$termsData = this.termsData) === null || _this$termsData === void 0 || _this$termsData.map(item => {
            this.checkedAdditionalList.push(item);
          });
        } else {
          var _this$termsData2;
          this.form.clause = undefined;
          (_this$termsData2 = this.termsData) === null || _this$termsData2 === void 0 || _this$termsData2.map(item => {
            if (this.selected.includes(item.id + '')) {
              this.checkedAdditionalList.push(item);
            }
          });
        }
      } else {
        if (this.termsData.length) {
          var _this$termsData3;
          this.form.clause = 0;
          (_this$termsData3 = this.termsData) === null || _this$termsData3 === void 0 || _this$termsData3.map(item => {
            this.checkedAdditionalList.push(item);
          });
        }
      }
      if (!this.checkedAdditionalList.length) {
        this.form.clause = 0;
        if (this.termsData.length) {
          var _this$termsData4;
          (_this$termsData4 = this.termsData) === null || _this$termsData4 === void 0 || _this$termsData4.map(item => {
            this.checkedAdditionalList.push(item);
          });
        }
      }
      let arr = (_this$checkedAddition = this.checkedAdditionalList) === null || _this$checkedAddition === void 0 ? void 0 : _this$checkedAddition.map(i => i.id);
      this.$emit('clauseData', arr);
    },
    // 删除当前数据中的某个城市
    delAreaItem(i, i1) {
      var _this$showArea, _this$templateData;
      let del = this.currentAreaShowList.findIndex(item => item[0][0] === this.showArea[i].code && item[0][1] === this.showArea[i].city[i1].code);
      if (this.showArea[i].city.length === 1) {
        this.showArea.splice(i, 1);
      } else {
        this.showArea[i].city.splice(i1, 1);
      }
      this.currentAreaShowList.splice(del, 1);
      let disabled = [];
      (_this$showArea = this.showArea) === null || _this$showArea === void 0 || _this$showArea.map(item => {
        // disabled.push(item.code + '');
        if (item.city && item.city.length) {
          var _item$city;
          (_item$city = item.city) === null || _item$city === void 0 || _item$city.map(item1 => {
            disabled.push(item1.code + '');
          });
        }
      });
      (_this$templateData = this.templateData) === null || _this$templateData === void 0 || _this$templateData.map((item, i) => {
        if (i !== this.currentTableIndex) {
          var _item$areaCode;
          (_item$areaCode = item.areaCode) === null || _item$areaCode === void 0 || (_item$areaCode = _item$areaCode.split(',')) === null || _item$areaCode === void 0 || _item$areaCode.map(item => {
            disabled.push(item);
          });
        }
      });
      this.getFilteredArea(disabled);
    },
    // 转换当前区域展示数据
    getcurrentAreaShowList(codes) {
      this.currentAreaShowList = [];
      this.showArea = [];
      if (codes && codes.length) {
        this.areaList.map(item => {
          item.child.map(cItem => {
            if (codes.includes(cItem.code + '')) {
              let res = this.getAreaName([item.code, cItem.code], this.areaList, 0, []);
              this.currentAreaShowList.push([[item.code, cItem.code], res]);
            }
          });
        });
        this.currentAreaShowList.map(item => {
          let res = false;
          if (this.showArea.length) {
            res = false;
            this.showArea.map(shows => {
              if (shows.code == item[0][0]) {
                let ii = shows.city.findIndex(cc => cc.code == item[0][1]);
                if (ii < 0) {
                  shows.city.push({
                    code: item[0][1],
                    name: item[1][1]
                  });
                }
                res = false;
              } else {
                res = true;
              }
            });
          } else {
            res = true;
          }
          if (res) {
            this.showArea.push({
              code: item[0][0],
              name: item[1][0],
              city: [{
                code: item[0][1],
                name: item[1][1]
              }]
            });
          }
        });
      }
    },
    // 打开选择区域弹框
    openArea(index) {
      var _this$templateData$in;
      this.getcurrentAreaShowList((_this$templateData$in = this.templateData[index].areaCode) === null || _this$templateData$in === void 0 ? void 0 : _this$templateData$in.split(','));
      this.currentTableIndex = index;
      // this.showArea = recursionCopy(this.templateData[index].showArea || []);
      // this.currentAreaShowList = recursionCopy(this.templateData[index].currentAreaShowList || []);
      this.areaVisible = true;
      this.getFilteredArea(this.delDuplicated());
    },
    // 保存当前数据已选所有城市
    saveArea() {
      this.tableDataNum = -1;
      if (this.showArea.length) {
        let arr = [];
        this.tableAreaName = '';
        let allAreaCode = [];
        this.showArea.forEach(item => {
          allAreaCode.push(item.code);
          if (item.city && item.city.length) {
            this.tableAreaName += item.name + '>';
            let areaName = '';
            item.city.forEach((area, i) => {
              allAreaCode.push(area.code);
              arr.push(area.code);
              areaName = areaName + area.name + (item.city.length - 1 != i ? '/' : '');
            });
            this.tableAreaName += areaName + '、';
          } else {
            arr.push(item.code);
            this.tableAreaName += item.name + '、';
          }
        });
        this.templateData[this.currentTableIndex].areaName = this.tableAreaName;
        this.templateData[this.currentTableIndex].areaCode = arr.join(',');
        this.templateData[this.currentTableIndex].allAreaCode = allAreaCode.join(',');
        this.templateData[this.currentTableIndex].index = this.currentTableIndex + 1;
        this.$set(this.templateData, this.currentTableIndex, this.templateData[this.currentTableIndex]);
        this.showArea = [];
        this.getFilteredArea(this.delDuplicated());
        this.areaVisible = false;
        let obj = {
          price: `${this.form.priceMin},${this.form.priceMax}`,
          area: this.templateData
        };
        this.$emit('premiumData', obj);
      } else {
        this.$message.warning(this.$t('请先选择区域'));
      }
    },
    // 过滤禁用城市
    getFilteredArea(disabled) {
      if (disabled.length) {
        var _this$areaList, _this$areaList2;
        (_this$areaList = this.areaList) === null || _this$areaList === void 0 || _this$areaList.map((i, index) => {
          this.areaList[index].disabled = false;
          if (i.child && i.child.length) {
            var _i$child;
            (_i$child = i.child) === null || _i$child === void 0 || _i$child.map((c, cindex) => {
              this.areaList[index].child[cindex].disabled = false;
            });
          }
        });
        (_this$areaList2 = this.areaList) === null || _this$areaList2 === void 0 || _this$areaList2.map((i, index) => {
          if (disabled.includes(i.code + '') && (!i.child || !i.child.length)) {
            this.areaList[index].disabled = true;
            // i.disabled = true;
          } else {
            if (i.child && i.child.length) {
              var _i$child2;
              (_i$child2 = i.child) === null || _i$child2 === void 0 || _i$child2.map((c, cindex) => {
                if (disabled.includes(c.code + '') || disabled.includes(i.code + '')) {
                  this.areaList[index].child[cindex].disabled = true;
                  this.areaList[index].child[0].disabled = true;
                } else {
                  this.areaList[index].child[cindex].disabled = false;
                }
              });
            } else {
              this.areaList[index].disabled = false;
            }
          }
        });
        // this.areaList.splice(0);
        // this.areaList.push(...arr);
        console.log(this.areaList);
        if (this.areaList[0].name == this.$t('全部')) {
          this.areaList[0].disabled = true;
        }
      } else {
        var _this$areaList3;
        (_this$areaList3 = this.areaList) === null || _this$areaList3 === void 0 || _this$areaList3.map((i, index) => {
          this.areaList[index].disabled = false;
          if (i.child && i.child.length) {
            var _i$child3;
            (_i$child3 = i.child) === null || _i$child3 === void 0 || _i$child3.map((c, cindex) => {
              this.areaList[index].child[cindex].disabled = false;
            });
          }
        });
      }
    },
    // 保存选中某一个城市
    addAreaList() {
      var _this$showArea2, _this$templateData2;
      if (this.showArea.find(i => i.code === '') || this.currentArea[0] === '') {
        this.currentAreaShowList.splice(0);
        this.showArea.splice(0);
      }
      let res = this.getAreaName(this.currentArea, this.areaList, 0, []);
      if (!this.showArea.length || !this.showArea.find(i => i.code == this.currentArea[0])) {
        this.showArea.push({
          code: this.currentArea[0],
          name: res[0],
          city: []
        });
      }
      this.currentAreaShowList.push([this.currentArea, res]);
      this.currentAreaShowList.forEach(item => {
        this.showArea.forEach(area => {
          if (item[0][0] == area.code && !area.city.find(i => i.code == item[0][1])) {
            area.city.push({
              code: item[0][1],
              name: item[1][1]
            });
          }
        });
      });
      let disabled = [];
      (_this$showArea2 = this.showArea) === null || _this$showArea2 === void 0 || _this$showArea2.map(item => {
        // disabled.push(item.code + '');
        if (item.city && item.city.length) {
          var _item$city2;
          (_item$city2 = item.city) === null || _item$city2 === void 0 || _item$city2.map(item1 => {
            disabled.push(item1.code + '');
          });
        }
      });
      (_this$templateData2 = this.templateData) === null || _this$templateData2 === void 0 || _this$templateData2.map((item, i) => {
        if (i !== this.currentTableIndex) {
          var _item$areaCode2;
          (_item$areaCode2 = item.areaCode) === null || _item$areaCode2 === void 0 || (_item$areaCode2 = _item$areaCode2.split(',')) === null || _item$areaCode2 === void 0 || _item$areaCode2.map(item => {
            disabled.push(item);
          });
        }
      });
      this.getFilteredArea(disabled);
      this.currentArea = [];
    },
    // 判断去重area
    delDuplicated() {
      let list = [];
      this.templateData.forEach(item => {
        if (item.areaCode) {
          list = list.concat(item.areaCode.split(','));
        }
      });
      return list;
    },
    getAreaName(code, data, currentIndex = 0, newName = []) {
      data.forEach(item => {
        if (code[currentIndex] == item.code) {
          newName[currentIndex] = item.name;
        }
        if (item.child) {
          this.getAreaName(code, item.child, currentIndex + 1, newName);
        }
      });
      // if (newName.length == 1) {
      //   newName.push('全部');
      // }
      return newName;
    },
    emitInfo() {
      this.$refs.price2.onFieldChange();
      let obj = {
        price: `${this.form.priceMin},${this.form.priceMax}`,
        area: this.templateData
      };
      this.$set(this.form, this.form.priceMin, this.form.priceMin);
      this.$set(this.form, this.form.priceMax, this.form.priceMax);
      this.$emit('premiumData', obj);
    },
    addAreaPremium() {
      let errPrice = this.templateData.find(i => !i.price || !i.areaName);
      let errInfo = this.templateData.find(i => Number(i.price) < Number(this.form.priceMin) || Number(i.price) > Number(this.form.priceMax));
      this.onSubmit();
      if (errPrice) {
        return this.$message.warn(this.$t('请先完善上一条数据'));
      }
      if (errInfo) {
        return this.$message.warn(this.$t('输入保费不得超出保费范围'));
      }
      if (this.tableDataNum > -1) {
        return;
      }
      let data = this.templateData[this.templateData.length - 1];
      if (data !== null && data !== void 0 && data.areaName && data !== null && data !== void 0 && data.price && Number(data === null || data === void 0 ? void 0 : data.price) >= Number(this.form.priceMin) && Number(data === null || data === void 0 ? void 0 : data.price) <= Number(this.form.priceMax) || this.templateData.length == 0) {
        this.templateData.push({
          areaName: '',
          price: undefined
        });
        this.emitInfo();
      } else {
        // this.$message.warn('请先完善上一条数据');
      }
    },
    changePrice(price) {
      this.tableDataNum = -1;
      if (!this.form.priceMin || !this.form.priceMax) {
        this.$refs.price2.onFieldChange();
        return;
      }
      if (!price) {
        return this.$message.warn(this.$t('请输入') + this.$t('保费'));
      }
      if (Number(this.form.priceMin) > Number(this.form.priceMax)) {
        return this.$message.warn(this.$t('区域保费最大值不能小于最小值'));
      } else if (Number(this.form.priceMin) == Number(this.form.priceMax)) {
        return this.$message.warn(this.$t('区域保费范围值不能相同'));
      }
      if (Number(price) < Number(this.form.priceMin) || Number(price) > Number(this.form.priceMax)) {
        return this.$message.warn(this.$t('输入保费不得超出保费范围'));
      }
      if (Number(this.form.priceMin) > 40000000 || Number(this.form.priceMax) > 40000000) {
        return this.$message.warn(this.$t('输入保费不能大于40000000'));
      }
      let obj = {
        price: `${this.form.priceMin},${this.form.priceMax}`,
        area: this.templateData
      };
      this.$emit('premiumData', obj);
    },
    ondeselect(value) {
      var _this$attachData;
      (_this$attachData = this.attachData) === null || _this$attachData === void 0 || _this$attachData.map((item, i) => {
        if (item.attachId == value) {
          this.attachData[i].buyLimit = 0;
        }
      });
    },
    changeAttach() {
      var _this$attachData2;
      let oldData = recursionCopy(this.additionalData);
      this.additionalData.splice(0, this.additionalData.length);
      (_this$attachData2 = this.attachData) === null || _this$attachData2 === void 0 || _this$attachData2.map(item => {
        var _this$form$attach;
        (_this$form$attach = this.form.attach) === null || _this$form$attach === void 0 || _this$form$attach.map(id => {
          if (item.attachId == id) {
            if (oldData.length) {
              let resIndex = oldData.findIndex(i => i.attachId == item.attachId);
              if (resIndex > -1) {
                item.buyLimit = oldData[resIndex].buyLimit;
              } else {
                item.buyLimit = 0;
              }
            } else {
              item.buyLimit = item.buyLimit ? item.buyLimit : 0;
            }
            let obj = recursionCopy(item);
            obj.attachId = obj.attachId.toString();
            this.additionalData.push(obj);
          }
        });
      });
      this.$emit('additionalData', this.additionalData);
    },
    delAdditionalData(info, i) {
      var _this$attachData3;
      this.additionalData.splice(i, 1);
      this.form.attach.splice(this.form.attach.findIndex(i => i === info.attachId), 1);
      (_this$attachData3 = this.attachData) === null || _this$attachData3 === void 0 || _this$attachData3.map((item, i) => {
        if (item.attachId == info.attachId) {
          this.attachData[i].buyLimit = 0;
        }
      });
      this.$emit('additionalData', this.additionalData);
    },
    changeType(e, info, i) {
      info.buyLimit = e.target.value;
      this.$set(this.additionalData, i, info);
      this.$emit('additionalData', this.additionalData);
    },
    changeClause() {
      var _this$checkedAddition2;
      if (this.form.clause === 0) {
        var _this$termsData5;
        this.checkedAdditionalList.splice(0);
        (_this$termsData5 = this.termsData) === null || _this$termsData5 === void 0 || _this$termsData5.map(item => {
          this.checkedAdditionalList.push(item);
        });
      } else {
        if (this.checkedAdditionalList.length && this.checkedAdditionalList.findIndex(i => i.id == this.form.clause) > -1) {
          this.form.clause = undefined;
          this.$message.warn(this.$t('该条款已选择'));
        } else {
          var _this$termsData6;
          (_this$termsData6 = this.termsData) === null || _this$termsData6 === void 0 || _this$termsData6.map(item => {
            if (item.id == this.form.clause) {
              this.checkedAdditionalList.push(item);
              this.form.clause = undefined;
              return;
            }
          });
          if (this.termsData.length && this.termsData.length == this.checkedAdditionalList.length) {
            this.form.clause = 0;
          }
        }
      }
      let arr = (_this$checkedAddition2 = this.checkedAdditionalList) === null || _this$checkedAddition2 === void 0 ? void 0 : _this$checkedAddition2.map(i => i.id);
      if (this.checkedAdditionalList.length == this.termsData.length) {
        this.form.clause = 0;
      }
      this.$refs.clause.onFieldChange();
      this.$emit('clauseData', arr);
    },
    delClause(value, index) {
      var _this$checkedAddition3;
      this.checkedAdditionalList.splice(index, 1);
      let arr = (_this$checkedAddition3 = this.checkedAdditionalList) === null || _this$checkedAddition3 === void 0 ? void 0 : _this$checkedAddition3.map(i => i.id);
      if (this.checkedAdditionalList.length != this.termsData.length) {
        this.form.clause = undefined;
      }
      this.$refs.clause.onFieldChange();
      this.$emit('clauseData', arr);
    },
    delArea(i) {
      this.templateData.splice(i, 1);
      let obj = {
        price: `${this.form.priceMin},${this.form.priceMax}`,
        area: this.templateData
      };
      this.$emit('premiumData', obj);
    },
    textChange(type) {
      this.form[type] = this.form[type].replace(/^\./g, '').replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/(\.)(\d*)(1\1*)/g, '$1$2');
      if (this.form[type].split('.').length > 2 && this.form[type][this.form[type].length - 1] == '.') {
        this.form[type] = this.form[type].substring(0, this.form[type].length - 1);
      }
    },
    textTemplateChange(index) {
      this.templateData[index].price = this.templateData[index].price.replace(/^\./g, '').replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      if (this.templateData[index].price.split('.').length > 2 && this.templateData[index].price[this.templateData[index].price.length - 1] == '.') {
        this.templateData[index].price = this.templateData[index].price.substring(0, this.templateData[index].price.length - 1);
      }
      let obj = {
        price: `${this.form.priceMin},${this.form.priceMax}`,
        area: this.templateData
      };
      this.$emit('premiumData', obj);
    },
    onSubmit() {
      this.tableDataNum = -1;
      if (this.templateData.length > 0) {
        for (let i = 0; i < this.templateData.length; i++) {
          var _String;
          let price = [this.form.priceMin, this.form.priceMax];
          const obj = recursionCopy(this.templateData[i]);
          let isOver = Number(obj.price) < Number(price[0]) || Number(obj.price) > Number(price[1]) || Number(obj.price) == 0;
          let valid1 = Number(obj.price) <= 0;
          let valid2 = String(obj.price).charAt(0) == '.';
          let valid3 = ((_String = String(obj.price)) === null || _String === void 0 || (_String = _String.split('.')[1]) === null || _String === void 0 ? void 0 : _String.length) > 2;
          if (!obj.areaName || !obj.price) {
            this.tableDataNum = i;
            // this.$message.error('需要把第' + Number(i + 1) + '行配置完成,才可以保存');
            break;
          } else if (isOver) {
            this.tableDataNum = i;
            break;
          } else if (valid1) {
            this.tableDataNum = i;
            break;
          } else if (valid2) {
            this.tableDataNum = i;
            break;
          } else if (valid3) {
            this.tableDataNum = i;
            break;
          }
        }
      }
      if (this.tableDataNum != -1) {
        return false;
      }
      this.$emit('save', this.index, this.templateData);
    },
    tableRowClass(record, index) {
      if (index == this.tableDataNum) {
        return 'rowClass';
      }
      return '';
    }
  }
};